export const isSafari = () =>
  typeof navigator === "undefined"
    ? false
    : navigator.userAgent.indexOf("Safari") > -1 &&
      navigator.userAgent.indexOf("Chrome") === -1
